/**
 * Смещение периода предложения. Соответствует словарю tariff_period_alignment
 * @prop CALENDAR = 1, // Календарный
 * @prop EVENT = 2, // По событию
 */

export enum TariffPeriodAlignments {
  CALENDAR = 1, // Календарный
  EVENT = 2, // По событию
}
